import { render, staticRenderFns } from "./CategoryMaster.vue?vue&type=template&id=0b8d5da8&scoped=true"
import script from "./CategoryMaster.vue?vue&type=script&lang=js"
export * from "./CategoryMaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8d5da8",
  null
  
)

export default component.exports